import { IMedicalRecordAllele } from '@nkr/models/hla/hla-medical-record-allele';
export { IMedicalRecordAllele } from '@nkr/models/hla/hla-medical-record-allele';

export interface IDonorHlaReviewHistory {
    id: number,
    donorId: number,
    reviewedDateTime: string,
    reviewedByUserId: number,
    reviewedByName: string,
    reviewNotes: string,
    reviewType: string,
    logDateTime: string,
    reviewedByInitials: string,
    labReviewedAntigens: boolean,
}

export interface IDonorProfileHlaInfoPostData {
    hlaA1: number,
    hlaA2: number,
    hlaB1: number,
    hlaB2: number,
    hlaBw1: number,
    hlaBw2: number,
    hlaC1: number,
    hlaC2: number,

    hlaDrb1: number,
    hlaDrb2: number,
    hlaHasDr51: boolean,
    hlaHasDr52: boolean,
    hlaHasDr53: boolean,

    hlaDqb1: number,
    hlaDqb2: number,
    hlaDqa1: number,
    hlaDqa2: number,

    hlaDpb1: number,
    hlaDpb2: number,
    hlaDpa1: number,
    hlaDpa2: number,

    labReviewComplete: boolean,
    labReviewDate: string,
    labReviewInitials: string
}

export interface IDonorProfileHlaInfoData extends IDonorProfileHlaInfoPostData {
    donorId: number,
    donorAlias: string,
    hasAlleleData: boolean,
    hlaDiscrepancyIsEquivalent: boolean,
    hasHlaMissingErrors: boolean,
    hasHlaDiscrepancy: boolean,
    
    reviewHistoryList: IDonorHlaReviewHistory[],
    hlaDiscrepancies: string[],

    alleles: IMedicalRecordAllele[] | null,
}

export interface IDonorProfileHlaInfoLookupData {
    hlaValueList: IDonorProfileHlaValues[]
}

export interface IDonorProfileHlaValues {
    hla: string,
    antigens: number[]
}
